import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";



const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const TermsAndConditions = () => {
  const [terms, setTerms] = useState("");
  const [rowData, setRowData] = useState([]);
  const [errors, setErrors] = useState("");
  const [editingTerm, setEditingTerm] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [alert, setAlert] = useState({ message: "", type: "" }); // Alert state

  useEffect(() => {
    // axios
      // .get("http://localhost:3036/terms")
      axios.get(`${API_BASE_URL}/terms`)

      .then((response) => {
        setRowData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
          document.title = 'Terms and Conditions - Calendar Services';
        }, []);


             useEffect(() => {
                  if (alert.message) {
                    const timer = setTimeout(() => setAlert({ message: "", type: "" }), 3000);
                    return () => clearTimeout(timer);
                  }
                }, [alert]);



  

  const columnDefs = [
    { headerName: "S.No", valueGetter: (params) => params.node.rowIndex + 1 },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <div className="flex space-x-2">
          <button
            className="text-blue-500 hover:underline"
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
          <button
            className="text-red-500 hover:underline"
            onClick={() => handleDelete(params.data.id)}
          >
            Delete
          </button>
        </div>
      ),
    },
    { headerName: "Terms and Conditions", field: "data", flex: 1 },
    { headerName: "Added By", field: "cby" },
  ];

  const handleSave = () => {
    const loggedInUser = localStorage.getItem("username");

    if (!terms.trim()) {
      setErrors("Terms and Conditions cannot be empty.");
      return;
    }

    if (editingTerm) {
      const updatedTerm = { id: editingTerm.id, terms, mby: loggedInUser };

      // axios
        // .put(`http://localhost:3036/terms/${editingTerm.id}`, updatedTerm)
        axios.put(`${API_BASE_URL}/terms/${editingTerm.id}`, updatedTerm)

        .then(() => {
          const updatedData = rowData.map((term) =>
            term.id === editingTerm.id
              ? { ...term, data: terms, mby: loggedInUser }
              : term
          );
          setRowData(updatedData);
          gridApi.setRowData(updatedData);
          setEditingTerm(null);
          setTerms("");
          setErrors("");
          setAlert({ message: "Terms and conditions updated successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error updating term:", error);
          setAlert({ message: "Error updating term.", type: "error" });
        });
    } else {
      const newTerm = { terms, cby: loggedInUser };
      axios
        // .post("http://localhost:3036/terms", newTerm)
        .post(`${API_BASE_URL}/terms`, newTerm)

        .then((response) => {
          const updatedData = [...rowData, { ...newTerm, id: response.data.id }];
          setRowData(updatedData);
          gridApi.setRowData(updatedData);
          setTerms("");
          setErrors("");
          setAlert({ message: "Terms and conditions added successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error adding term:", error);
          setAlert({ message: "Error adding term.", type: "error" });
        });
    }
  };

  const handleEdit = (term) => {
    setEditingTerm(term);
    setTerms(term.data);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this term?")) {
      axios
        .delete(`${API_BASE_URL}/terms/${id}`)
        .then(() => {
          const updatedData = rowData.filter((row) => row.id !== id);
          setRowData(updatedData);
          gridApi.setRowData(updatedData);
          setAlert({ message: "Term deleted successfully!", type: "success" });
        })
        .catch((error) => {
          console.error("Error deleting term:", error);
          setAlert({ message: "Error deleting term.", type: "error" });
        });
    }
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  return (
    <div className="bg-gray-100 p-6">
      <div className="max-w-3xl mx-auto mt-8 bg-white shadow-md rounded mb-9">
        <div className="bg-teal-500 text-white px-6 py-3 rounded-t">
          <h2 className="text-xl font-bold">Terms and Conditions</h2>
        </div>
        <div className="p-4">
          <textarea
            value={terms}
            onChange={(e) => setTerms(e.target.value)}
            className="w-full mb-1 p-3 border rounded"
            rows="4"
            placeholder="Enter terms and conditions"
          ></textarea>
          {errors && <p className="text-red-500 text-sm mt-1">{errors}</p>}
          <div className="flex justify-end">
            <button
              onClick={handleSave}
              className="mt-5 bg-blue-500 text-white px-6 py-2 rounded shadow hover:bg-blue-600 transition"
            >
              {editingTerm ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-8 bg-white shadow-md rounded">
        <div className="p-6">
          <h2 className="text-blue-600 text-xl font-bold mb-6">
            View Terms And Conditions
          </h2>
          <div
            className="ag-theme-alpine"
            style={{ height: 500, width: "100%" }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={8}
              onGridReady={onGridReady}
              defaultColDef={{ sortable: true, filter: true, editable:true }}
            />
          </div>
        </div>
      </div>

      {alert.message && (
        <div
          className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg z-50 ${
            alert.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          <span>{alert.message}</span>
        </div>
      )}
    </div>
  );
};

export default TermsAndConditions;
